export const STORE_CITY_DETAIL_REQUESTED = 'STORE_CITY_DETAIL_REQUESTED';
export const storeCityDetailRequested = cityDetails => ({
    type: STORE_CITY_DETAIL_REQUESTED,
    cityDetails,
});

export const STORE_CITY_DETAIL = 'STORE_CITY_DETAIL';
export const storeCityDetail = (locale, city) => ({
    type: STORE_CITY_DETAIL,
    locale,
    city,
});

export const REPORT_AUTOCOMPLETE_ERROR = 'REPORT_AUTOCOMPLETE_ERROR';
export const reportAutocompleteError = (id, level, direction) => ({
    type: REPORT_AUTOCOMPLETE_ERROR,
    id,
    level,
    direction,
});

export const CLEAR_AUTOCOMPLETE_ERROR = 'CLEAR_AUTOCOMPLETE_ERROR';
export const clearAutocompleteError = direction => ({
    type: CLEAR_AUTOCOMPLETE_ERROR,
    direction,
});

export const TOGGLE_AUTOCOMPLETE_LOADING = 'TOGGLE_AUTOCOMPLETE_LOADING';
export const toggleAutocompleteLoading = (direction, loading) => ({
    type: TOGGLE_AUTOCOMPLETE_LOADING,
    direction,
    loading,
});

export const SET_DEPARTURE_LOCATION = 'SET_DEPARTURE_LOCATION';
export const setDepartureLocation = id => ({
    type: SET_DEPARTURE_LOCATION,
    id,
});

export const SET_ARRIVAL_LOCATION = 'SET_ARRIVAL_LOCATION';
export const setArrivalLocation = id => ({
    type: SET_ARRIVAL_LOCATION,
    id,
});

export const SWITCH_LOCATIONS = 'SWITCH_LOCATIONS';
export const switchLocations = () => ({
    type: SWITCH_LOCATIONS,
});

export const REQUEST_AUTOCOMPLETE = 'REQUEST_AUTOCOMPLETE';
export const requestAutocomplete = (query, direction, key, sendDepartureCityId = false) => ({
    type: REQUEST_AUTOCOMPLETE,
    query,
    direction,
    key,
    sendDepartureCityId,
});

export const CLEAR_AUTOCOMPLETE_RESULTS = 'CLEAR_AUTOCOMPLETE_RESULTS';
export const clearAutocomplete = direction => ({
    type: CLEAR_AUTOCOMPLETE_RESULTS,
    direction,
});

export const STORE_AUTOCOMPLETE_RESULTS = 'STORE_AUTOCOMPLETE_RESULTS';
export const storeAutocompleteResults = (results, direction, key) => ({
    type: STORE_AUTOCOMPLETE_RESULTS,
    direction,
    key,
    results,
});

export const UPDATE_LOCATIONS = 'UPDATE_LOCATIONS';
export const updateLocations = (fromCityDetails, toCityDetails) => ({
    type: UPDATE_LOCATIONS,
    fromCityDetails,
    toCityDetails,
});
